import * as React from 'react';

import { IExtraProduct } from 'src/model/productdetails.model';
import env from 'src/shared/env';

import './ShipFromTab.scss';
import ShipFromRow from '../ShipFromRow';
import { type } from 'os';

export interface IPart {
  images: string[];
  modelsFound: number;
  name: string;
  productNumber: string;
  description: string;
  price: number;
  msrp: number;
  inStock: boolean;
  supplierQuantity: number;
  state: string;
  extraProducts: IExtraProduct[];
  extraTotalAmount: number;
  pickUpFrom: string;
  pickUpTo: string;
  shipFrom: string;
  shipToName: string;
  shipToAddress: string;
  manufacturer?: string;
  manufacturerCode?: string;
  replacedPart: string;
  replacedMfc: string;
  stateDescription: string;
  specialOrder: boolean;
  discountInfo: any;
}

interface IDeliverAddress {
  warehouseCode: string;
  description: string;
  quantity: number;
  name: string;
  code: string;
  default: boolean;
  addressLine1: string;
  addressLine2: string;
  addressLine4: string;
  stateCode: string;
  postalCode: string;
  pickUpOnly: boolean;
}

interface IShipFromTabProps {
  deliverAddresses: IDeliverAddress[];
  defaultWarehouse: any;
  supplierQuantity: number;
  showPickUpOnly: boolean;
  type: 'shipping' | 'pick-up' | '';
  selectedtab: number;
  selectedAddresses: object;
  handleChangeAddress: (selectedAddresses: object) => void;
  part: IPart;
  handleChangeShipTo(): void;
  isAddedToCart: boolean;
  setAddedToCart: (val: boolean) => void;
  isMounted: boolean;
  setMounted: (val: boolean) => void;
  defaultItemsToShow: number;
  handleOnInputChange: (
    warehouse: string,
    qty: string,
    available: number,
    setAlert: (params: any) => void
  ) => void;
  getWarehouses: () => any;
  setDefaultValues: () => void;
  setSelectedAddresses: (selectedAddress: any) => void;
  getShipFromAddresses: (value?: boolean) => void;
  cartDeliverMethod: 'shipping' | 'pick-up' | '';
  t?: any;
}

interface IShipFromTabState {
  selectedAddresses: object;
  zipCode: string;
  itemsToShow: number;
  expanded: boolean;
}

let MAX_LENGTH_ELEMENTS = 4;

class ShipFromTab extends React.Component<
  IShipFromTabProps,
  IShipFromTabState
> {
  public scrollDiv: any;
  constructor(props: any) {
    super(props);
    this.state = {
      selectedAddresses: {},
      zipCode: '',
      itemsToShow: this.props.defaultItemsToShow,
      expanded: false
    };
    this.scrollDiv = React.createRef();
    MAX_LENGTH_ELEMENTS = this.props.defaultItemsToShow;
  }

  private showMore = () => {
    this.state.itemsToShow === this.props.defaultItemsToShow
      ? this.setState({
          itemsToShow: this.props.deliverAddresses.length,
          expanded: true
        })
      : this.setState({
          itemsToShow: this.props.defaultItemsToShow,
          expanded: false
        });
  };

  private scrollSmoothHandler = () => {
    this.scrollDiv.current.scrollIntoView({ behavior: 'smooth' });
  };

  public componentDidMount() {
    if (!this.props.isMounted) {
      this.props.setSelectedAddresses(this.props.selectedAddresses);
    } else {
      this.props.setDefaultValues();
      this.props.setMounted(false);
    }
  }

  public componentDidUpdate(prevProps: any) {
    if (
      this.props.isMounted &&
      Object.keys(this.props.selectedAddresses)[0] !==
        Object.keys(prevProps.selectedAddresses)[0]
    ) {
      this.props.setMounted(false);
    } else {
      if (
        Object.keys(this.props.selectedAddresses)[0] !==
        Object.keys(prevProps.selectedAddresses)[0]
      ) {
        this.props.setSelectedAddresses(this.props.selectedAddresses);
      }
    }

    if (
      this.props.isAddedToCart &&
      this.props.isAddedToCart !== prevProps.isAddedToCart
    ) {
      this.props.setDefaultValues();
      this.props.setAddedToCart(false);
    }
  }

  public render() {
    const { t } = this.props;
    return (
      <div className="rp-ship-from-tab--info">
        <div ref={this.scrollDiv} className="rp-ship-from-tab--ship-to-address">
          <p className="rp-ship-from-tab--address-title">
            {t('product.shippingAddress')}:
          </p>
          {this.props.part.shipToAddress && (
            <div className="rp-ship-from-tab--address">
              <span className="rp-ship-from-tab--address--name">
                {this.props.part.shipToName !== ''
                  ? this.props.part.shipToName + ': '
                  : 'One Time Address: '}
              </span>
              <span className="rp-ship-from-tab--address--info">
                {this.props.part.shipToAddress !== ''
                  ? this.props.part.shipToAddress
                  : 'N/A'}
              </span>
              <button
                className="rp-ship-from-tab--address--change"
                onClick={this.props.handleChangeShipTo}
              >
                {t('common.change')}
              </button>
            </div>
          )}
        </div>
        <div className="rp-ship-from-tab--directions-text">
          {t('product.suppliedFrom')}:
        </div>
        <div className="rp-ship-from-tab--addresses">
          <div className="rp-ship-from-tab--addresses--titles-desktop">
            <div className="rp-ship-from-tab--addresses--title-store-desktop">
              {t('product.store')}
            </div>
            <div className="rp-ship-from-tab--addresses--title-availability-desktop">
              {t('product.availability')}
            </div>
            <div className="rp-ship-from-tab--addresses--title-qty-desktop">
              {(t('myFavourites.qty') as string).toUpperCase()}:
            </div>
          </div>
          {this.props.deliverAddresses.length > 0 &&
            this.props
              .getWarehouses()
              .map((address: any) => (
                <ShipFromRow
                  key={address.warehouseCode}
                  address={address}
                  type={this.props.type}
                  selectedtab={this.props.selectedtab}
                  selectedAddresses={this.props.selectedAddresses}
                  handleInputChange={this.props.handleOnInputChange}
                  isBold={address.default}
                  stateQty={this.props.part.state}
                />
              ))}
          {this.props.deliverAddresses.length > MAX_LENGTH_ELEMENTS ? (
            <div
              className="rp-ship-from-tab--addresses--show-more-toggle"              
              onClick={this.showMore}
            >
              {this.state.expanded ? (
                <React.Fragment>
                  <div
                    onClick={this.scrollSmoothHandler}
                    className="rp-ship-from-tab--show-more-toggle"
                  > 
                  <></>
                  </div>
                  <div className="rp-deliver-address-change--supplier">
                    {t('product.manufacturerQuantity')}
                    <span className="rp-deliver-address-change--supplier-count">
                      {this.props.supplierQuantity}
                    </span>
                  </div>
                </React.Fragment>
              ) : (
                <React.Fragment>                  
                  <div className="rp-ship-from-tab--show-more-toggle">
                   <></>                 
                  </div>
                  <div className="rp-deliver-address-change--supplier">
                    {t('product.manufacturerQuantity')}
                    <span className="rp-deliver-address-change--supplier-count">
                      {this.props.supplierQuantity}
                    </span>
                  </div>
                </React.Fragment>
              )}
            </div>
          ) : (
            <React.Fragment>
              <div className="rp-deliver-address-change--supplier manufcode">
                {t('product.manufacturerQuantity')}
                <span className="rp-deliver-address-change--supplier-count">
                  {this.props.supplierQuantity}
                </span>
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    );
  }
}

export default ShipFromTab;
